import { Component, OnInit } from '@angular/core';
import { AuthService, FormErrors, RegisterForm } from "../login/auth.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterPage implements OnInit {
  public form: RegisterForm = new RegisterForm
  public errors: FormErrors = new FormErrors

  constructor(private authService: AuthService, private router: Router) {
  }

  ngOnInit() {
  }

  public register() {
    this.authService.register(this.form).then(result => {
      this.router.navigate(['thankyou']);
      }, err => {
        this.errors.list  = err.json().errors;
        console.log(this.errors);
      });
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/register/register.component.ts